import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../../utils/getAuthToken";

const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";

const authHeaders = async () => {
  const token = await getAuthToken();
  if (!token) throw new Error("No token found");
  return { Authorization: `Bearer ${token}` };
};

export const fetchTaskActivityHistory = createAsyncThunk(
  "taskActivityHistory/fetch",
  async ({ page = 1, limit = 50, search = "", entityType = "", action = "" } = {}, { rejectWithValue }) => {
    try {
      const headers = await authHeaders();
      const params = { page, limit, search };
      if (entityType) params.entityType = entityType;
      if (action) params.action = action;
      const response = await axios.get(`${SERVER_DOMAIN}/api/tasks/activity-history`, {
        headers,
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const taskActivityHistorySlice = createSlice({
  name: "taskActivityHistory",
  initialState: {
    rows: [],
    pagination: { page: 1, limit: 50, total: 0 },
    retentionDays: 30,
    loading: false,
    error: null,
  },
  reducers: {
    clearTaskActivityHistory: (state) => {
      state.rows = [];
      state.pagination = { page: 1, limit: 50, total: 0 };
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaskActivityHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaskActivityHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload.data || [];
        state.pagination = action.payload.pagination || state.pagination;
        state.retentionDays = action.payload.retentionDays ?? 30;
      })
      .addCase(fetchTaskActivityHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.rows = [];
      });
  },
});

export const { clearTaskActivityHistory } = taskActivityHistorySlice.actions;
export default taskActivityHistorySlice.reducer;
